import { getLegendStyle } from '../../theme/common/legend';
import { textColor, backgroundColor } from '../../theme/common/color';
import setDefault from './setDefault';
import setWithLegend from './setWithLegend';
import setRing from './setRing';
import setSmallRing from './setSmallRing';
import setProgress from './setProgress';
import { isType } from '../../utils/util';
import merge from 'lodash.merge';
import cloneDeep from 'lodash.clonedeep';
import setWithLabelLine from "./setWithLabelLine";

var getPieLegend = function getPieLegend(config, _ref) {
  var legend = _ref.legend;
  if (!legend) return;
  var legendConfig = getLegendStyle();

  if (config.orient === 'vertical') {
    merge(legendConfig, {
      orient: 'horizontal',
      top: '72%',
      itemGap: 20
    });
  } else {
    merge(legendConfig, {
      orient: 'vertical',
      top: 'middle',
      left: '66%'
    });
  }

  return legendConfig;
};

var getPieTooltip = function getPieTooltip(config) {
  return {};
};

var getPieSeries = function getPieSeries(config, series, legend, theme) {
  // 环形图的内圈阴影
  var ringSeries = [];
  series.forEach(function (chart) {
    if (!isType(chart, 'pie')) return;
    setDefault(chart);

    if (legend) {
      setWithLegend(chart, config.orient);
    }

    if (config.labelLine) {
      setWithLabelLine(chart, legend, theme);
    }

    if (config.ring) {
      setRing(chart, config);

      if (config.ringSize === 'small') {
        setSmallRing(chart, ringSeries);
      }

      if (config.ringType === 'progress') {
        setProgress(chart, config);
      }
    }
  });
  return series.concat(ringSeries);
};

export default function (config) {
  if (config === void 0) {
    config = {};
  }

  return function (options, theme) {
    var tooltip = getPieTooltip(config);
    var legend = getPieLegend(config, options);
    var series = getPieSeries(config, cloneDeep(options.series), legend, theme);
    return merge({
      tooltip: tooltip,
      legend: legend,
      series: series
    }, options);
  };
}